const wilmetteMenu = [
  {
    label: "Wine",
    items: [
      { name: "Corkage Fee", price: "$40.00", description: "Per bottle" },

      { name: "SPARKLING", price: "", description: "" },
      { name: "Mionetto Prosecco, Italy (187 ML)", price: "$12", description: "" },
      { name: "Frexinet, Spain (187 ML)", price: "$12", description: "" },
      { name: "Mionetto Lux Proseco Valdobbiadene, Italy", price: "$45", description: "" },
      { name: "GH Mumm Grand Cordon Brut, Champagne, France", price: "$80", description: "" },
      { name: "Dom Perignon, Champagne, France", price: "$290", description: "" },

      { name: "ROSÉ & MOSCATO", price: "", description: "" },
      { name: "Seven Daughters Moscato, Italy", price: "$12 / $38", description: "" },

      { name: "PINOT GRIGIO & RIESLING", price: "", description: "" },
      { name: "Cavi Pinot Grigio, Veneto, Italy", price: "$12 / $38", description: "" },
      { name: "San Angelo, Italy", price: "$15 / $45", description: "" },
      { name: "Santa Margherita, Italy", price: "$55", description: "" },
      { name: "Tertalo, Friuli, Italy", price: "$45", description: "" },
      { name: "Cht. St. Michelle Riesling, Columbia Valley, WA", price: "$38", description: "" },

      { name: "SAUVIGNON BLANC", price: "", description: "" },
      { name: "Oyster Bay, Marlborough, NZ", price: "$14 / $40", description: "" },
      { name: "Dark Horse, California", price: "$35", description: "" },
      { name: "Ferrari Carano Fumé Blanc, North Coast, California", price: "$50", description: "" },

      { name: "CHARDONNAY", price: "", description: "" },
      { name: "Simi, Sonoma, California", price: "$45", description: "" },
      { name: "Kendall Jackson, California", price: "$40", description: "" },
      { name: "William Hill, California", price: "$12 / $40", description: "" },
      { name: "Prayers of Saints, Washington", price: "$40", description: "" },
      { name: "Ferrari Carano, Sonoma, California", price: "$15 / $50", description: "" },

      { name: "CHIANTI", price: "", description: "" },
      { name: "1- Placido, Chianti, Italy", price: "$12 / $38", description: "" },
      { name: "2- Ruffino Superiore, Chianti, Italy", price: "$40", description: "" },
      { name: "3- Banfi Superiore, Chianti, Italy", price: "$37", description: "" },
      { name: "4- Rocco Delle Maci Classico, Chianti Classico, Italy", price: "$45", description: "" },
      { name: "5- Monsanto Riserva, Chianti Classico, Italy", price: "$65", description: "" },
      { name: "6- Villa Banfi Riserva, Chianti Classico, Italy", price: "$45", description: "" },
      { name: "7- Ruffino Ducale Riserva Tan, Chianti Classico, IT", price: "$16 / $64", description: "" },
      { name: "7a Chianti Classico Gran Selezione La Pagliala", price: "$50", description: "" },

      { name: "SUPER TUSCANS", price: "", description: "" },
      { name: "8- Rocca Delle Macie Sasyr, Tuscany, Italy", price: "$16 / $50", description: "" },
      { name: "9- Villa Antinori, Tuscany, Italy", price: "$60", description: "" },
      { name: "10- Ruffino Modus, Tuscany, Italy", price: "$60", description: "" },

      { name: "PINOT NOIR", price: "", description: "" },
      { name: "11- Mark West, California", price: "$12 / $40", description: "" },
      { name: "12- Jacobs Creek, Australia", price: "$50", description: "" },
      { name: "13- Coppola Votre Sante, California", price: "$40", description: "" },
      { name: "14- Diora La Petite Grace, Monterey, California", price: "$15 / $50", description: "" },
      { name: "Meiomi", price: "$15 / $50", description: "" },

      { name: "MERLOT", price: "", description: "" },
      { name: "17- William Hill, California", price: "$40", description: "" },

      { name: "ZINFANDEL", price: "", description: "" },
      { name: "18- Seven Deadly Zins, Lodi, California", price: "$45", description: "" },
      { name: "19- Rancho Zabaco, North Coast, California", price: "$40", description: "" },
      { name: "20- Paso Creek, Paso Robles, California", price: "$38", description: "" },
      { name: "27- Dancing Bull", price: "$14 / $40", description: "" },

      { name: "MALBEC", price: "", description: "" },
      { name: "21- Ruta 22, Mendoza, Argentina", price: "$40", description: "" },
      { name: "22- Casillero del Diablo, Chile", price: "$12 / $38", description: "" },
      { name: "23- Los Alamos, Argentina", price: "$40", description: "" },
      { name: "24- Dona Paula, Mendoza, Argentina", price: "$12 / $40", description: "" },

      { name: "SYRAH & RIOJA", price: "", description: "" },
      { name: "25- Barossa Valley GSM, Australia", price: "$12 / $40", description: "" },
      { name: "26- Concannon Petite Sirah, California", price: "$38", description: "" },
      { name: "28- Ergo, Rioja, Spain", price: "$45", description: "" },
      { name: "29- Las Rocas Garnacha, Rioja, Spain", price: "$45", description: "" },

      { name: "RED BLEND", price: "", description: "" },
      { name: "30- Chloe Red Blend, North Coast, California", price: "$40", description: "" },
      { name: "31- 1924 Double Black, Lodi, California", price: "$45", description: "" },
      { name: "32- Prayers of Sinners, Washington", price: "$40", description: "" },

      { name: "CABERNET SAUVIGNON", price: "", description: "" },
      { name: "33- Coppola Directors Cutz, Sonoma, California", price: "$65", description: "" },
      { name: "34- Franciscan, California", price: "$65", description: "" },
      { name: "35- Joseph Carr, Napa Valley, California", price: "$55", description: "" },
      { name: "36- Louis Martini, California", price: "$15 / $45", description: "" },
      { name: "37- Bonanza by Caymus, California", price: "$45", description: "" },
      { name: "38- B.R. Cohn, North Coast, California", price: "$15 / $50", description: "" },
      { name: "39- Mount Veeder, Napa Valley, California", price: "$80", description: "" },
      { name: "40- Brassfield, High Valley, California", price: "$15 / $50", description: "" },
      { name: "41- Casillero del Diablo, Chile", price: "$12 / $38", description: "" },

      { name: "SPECIAL SELECTION", price: "", description: "" },
      { name: "42- Ruffino Riserva Gold Label, Chianti Classico, IT", price: "$95", description: "" },
      { name: "43- Robert Mondavi Maestro Red Blend", price: "$90", description: "" },
      { name: "44- Napa Valley, California", price: "$95", description: "" },
      { name: "45- Lion Tamer Red Blend, Napa Valley, California", price: "$90", description: "" },
      { name: "46- The Prisoner Red Blend, Napa Valley, California", price: "$95", description: "" },
      { name: "47- Girard Artistry Red Blend, Napa Valley, California", price: "$100", description: "" },
      { name: "48- Barolo, Piedmont, Italy", price: "$95", description: "" },
      { name: "49- Brunello di Montalcino, Italy", price: "$110", description: "" },
      { name: "50- Chateauneuf Du Pape", price: "$80", description: "" },
      { name: "51- Brunello Di Montalcino Camigliano", price: "$95", description: "" },
    ],
  },
  {
    label: "Antipasti",
    items: [
      { name: "SCAMPI MEDITERRANEO", price: "$19", description: "Prawns sautéed in a garlic butter bordelaises sauce with a touch of red wine." },
      { name: "MUSSELS AND CLAMS A'OLIO", price: "$18", description: "Served sautéed with virgin olive oil, garlic, white wine, fresh tomatoes arrabiata sauce." },
      { name: "BEEF CARPACCIO", price: "$18", description: "Thin sliced fillet mignon served with arugula, diced tomatoes & cilantro balsamic sauce." },
      { name: "BANANA PEPPERS", price: "$17", description: "Stuffed with sauteed crumbled Italian sausage, mozzarella, rice vinegar and butter reduction." },
      { name: "CLAMS CASINO", price: "$18", description: "Fresh baked clams, pancetta, garlic, casino butter." },
      { name: "GRILLED CALAMARI", price: "$18", description: "Grilled calamari served w/fresh tomatoes, pepperoncini peppers, shaved garlic, black olives, capers & touch of garlic butter." },
      { name: "SCALLOPS CAPRICCIOS", price: "$20", description: "Pan seared scallops, diced tomatoes, dijon mustard sauce." },
      { name: "ESCAROLE AND SALSICCIA", price: "$18", description: "Escarole sauteed with garlic, italian sausage and navy beans, white wine and diced tomatoes." },
      { name: "FIOR DI LATTE", price: "$18", description: "Fresh mozzarella wrapped with prosciutto served grilled pesto vinaigrette top with arugula and balsamic glaze." },
    ],
  },
  {
    label: "Insalatas",
    items: [
      { name: "LA BELLA", price: "$15", description: "Fresh arugula, pears, dry figs & goat cheese, cranberries, caramelized pecans, passion fruit vinaigrette." },
      { name: "CAPRESE", price: "$17", description: "Sliced tomatoes, avocado, sweet red onions, buffalo mozzarella and fresh basil, red italian vinaigrette." },
      { name: "ROASTED BEET SALAD", price: "$15", description: "Gold & red beets, carrots, mixed greens, caramelized pecans, and gorgonzola cheese served with beet & bleu cheese dressing." },
      { name: "ICEBERG WEDGE", price: "$15", description: "Iceberg wedge served with crispy pancetta sweet red onions, cucumbers and tomatoes, radicchio, vinaigrette and gorgonzola dressing." },
      { name: "SPINACH SALAD", price: "$15", description: "Fresh spinach served with a hard boiled egg, mushrooms in a warm balsamic mustard & bacon vinaigrette." },
    ],
  },
  {
    label: "Zuppe",
    items: [
      { name: "Homemade Minestrone", price: "$9", description: "Made with fresh vegetables." },
      { name: "Chef's Soup of The Day", price: "$9", description: "Pregunte a su mesero." },
    ],
  },
  {
    label: "Pasta & Risottos",
    items: [
      { name: "CHECCA", price: "$24", description: "White angel hair, served sautéed with whole roasted garlic, virgin olive oil, fresh basil, diced tomatoes and white wine." },
      { name: "VERMICELLI AMATRICIANA", price: "$24", description: "Pasta served with sauteed shaved garlic, basil, tomatoes, bell peppers, and pancetta in arrabiata sauce." },
      { name: "BIETE", price: "$24", description: "Homemade fresh made ravioli filled with spinach, fresh ricotta cheese served with a light butter sage sauce." },
      { name: "PENNE FARCITA", price: "$25", description: "Penne pasta served with sautéed chunks of chicken, spinach, pancetta, fresh tomatoes in a white wine cream sauce." },
      { name: "CHICKEN RAVIOLI", price: "$24", description: "Ravioli stuffed with chicken, spinach and artichokes served in a arrabiata sauce." },
      { name: "LINGUINE AND CLAMS", price: "$28", description: "Pasta served sautéed with middle neck clams, garlic, parsley and white wine." },
      { name: "GNOCCHI DI CASA", price: "$30", description: "Homemade gnocchi served with chunks of filet mignon, broccoli, shaved garlic sundried tomatoes mushrooms in a olive oil sauce." },
      { name: "LANGOSTINO", price: "$27", description: "Homemade ravioli filled with chunks of lobster meat, ricotta cheese, fresh basil sundried tomatoes with lobster cream sauce." },
      { name: "LINGUINE PESCATORE", price: "$33", description: "Linguine served with shrimps, scallops, mussels, clams, shaved garlic and basil in a marinara sauce." },
      { name: "ZITTI PASTA AL PESTO GENOVESE", price: "$25", description: "Pasta served with broiled diced chicken breast with pesto cream sauce and cherry tomatoes." },
      { name: "RISOTTO AL FUNGI", price: "$25", description: "Arborio served with wild mushrooms & goat cheese." },
      { name: "RISOTTO GAMBERI", price: "$30", description: "Arborio served w/ prawns, shaved garlic, fresh tomatoes, spinach, and touch of tarragon." },
      { name: "BLACK PASTA", price: "$30", description: "Black angel hair served with sautéed shrimp scallops, red and green bell peppers, mushroom w/a champagne cream lobster reduction sauce." },
    ],
  },
  {
    label: "Veal",
    items: [
      { name: "VEAL CARLOS", price: "$35", description: "Veal scaloppini served with porcini mushrooms and regular mushrooms in a champagne cream reduction sauce." },
      { name: "VITELLO AL CARCIOFI", price: "$35", description: "Vitello scallopini sautéed with mushrooms, spinach, artichokes, in a roasted garlic plum tomato white wine sauce." },
      { name: "VEAL PAILLARD", price: "$35", description: "Veal scaloppini served broiled with portobello mushrooms, in a bordelaises garlic sauce." },
      { name: "VEAL FRANCESE", price: "$35", description: "Veal scaloppini & zucchini dipped in egg wash then sautéed & served with a white wine." },
      { name: "VEAL SORRENTO", price: "$35", description: "Stuffed scaloppini with provolone cheese, spinach, served with artichokes, diced tomatoes and bordelaise sauce." },
      { name: "VEAL PICCATA", price: "$35", description: "Scaloppini served sautéed with lemon caper butter sauce, touch of white wine." },
      { name: "VEAL PORTERHOUSE", price: "$45", description: "Bone in porterhouse, broiled and served with apricot brandy sauce." },
      { name: "VEAL CHOP MILANESE", price: "$45", description: "Veal chop dusted in seasoned bread crumbs with a light wine sauce." },
      { name: "VEAL CHOP AL ROSEMARINO", price: "$45", description: "Veal chop broil served with rosemary sauce." },
    ],
  },
  {
    label: "Pollo",
    items: [
      { name: "POLLO SOSTANZA", price: "$29", description: "Breast of chicken served sautéed to a crisp with butter sage and a touch of bordelaise sauce." },
      { name: "POLLO GIARDINARA", price: "$29", description: "Boneless chicken breast lightly breaded served with giardinara sauce." },
      { name: "POLLO VESUVIO", price: "$29", description: "Sautéed breast and thigh with lemon butter, oregano, garlic and white wine sauce." },
      { name: "POLLO A LA MARIO", price: "$29", description: "Grilled boneless chicken breast served with plum tomatoes, white zinfandel cream sauce." },
    ],
  },
  {
    label: "Carni",
    items: [
      { name: "FILLET MIGNON", price: "$44", description: "Served broiled with porccini and regular mushrooms touch of bordelaise sauce and a touch of cream." },
      { name: "RIBEYE PORTABELLA", price: "$45", description: "Boneless ribeye served broiled with portabella mushrooms, bordelaise sauce reduced with brandy." },
    ],
  },
  {
    label: "Pesce",
    items: [
      { name: "SALMON CARLOS", price: "$33", description: "Fillet of salmon served broiled with a Dijon mustard, glaze, julienne vegetables, in a sesame ginger vinaigrette." },
      { name: "SHRIMP GENOVESE", price: "$34", description: "Prawns served sautéed with garlic, white wine, over angel hair pasta with diced tomatoes and fresh basil." },
      { name: "FILET OF WHITE FISH", price: "$29", description: "Served sautéed with lemon caper butter sauce and julienne vegetables." },
      { name: "SCALLOPS PROVENCALE", price: "$38", description: "Sautéed scallops, cherry tomatoes, basil, white wine, touch of garlic butter over vermicelli." },
      { name: "GRILLATA DE MARE", price: "$34", description: "Fresh filet of white fish, shrimp, scallops over angel hair pasta with lemon butter oregano, garlic and white wine sauce." },
    ],
  },
];

export default wilmetteMenu;
